import { useEffect, useState } from 'react'
import { Modal } from '@unimpaired/react'
import { onMaintenance } from '../../config/maintenance'
import { SERVER_URL } from '../../config/axios.config'

// Renders nothing until a 503 maintenance response trips it (see
// config/maintenance.ts), then pops a modal and polls /livez. When the API
// answers again (the deploy removed the ALB 503 rule), it reloads to pick up
// the freshly deployed app + data.
export const MaintenanceWatcher = () => {
  const [active, setActive] = useState(false)

  useEffect(() => onMaintenance(() => setActive(true)), [])

  useEffect(() => {
    if (!active) return
    const id = setInterval(async () => {
      // /livez also 503s behind the maintenance rule, so a 200 means recovery.
      const recovered = await fetch(`${SERVER_URL}/livez`, { cache: 'no-store' })
        .then((res) => res.ok)
        .catch(() => false)
      if (recovered) window.location.reload()
    }, 5000)
    return () => clearInterval(id)
  }, [active])

  return (
    <Modal
      isOpen={active}
      type="modal"
      title="Maintenance in progress"
      // Not dismissable — the deploy decides when it's over (auto-reloads).
      hideCloseButton
      onClose={() => {}}>
      <div className="max-w-md p-6 text-center">
        <div className="mb-4 text-4xl">🛠️</div>
        <p className="text-gray-600">
          We're deploying an improvement — please come back in a few minutes.
          This page reconnects automatically, so there's no need to refresh.
        </p>
      </div>
    </Modal>
  )
}
